import { configureStore } from '@reduxjs/toolkit'
// import logger from 'redux-logger'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import { combineReducers } from "redux";
import { persistStore } from "redux-persist";
import languageReducer from './language/reducer';

const rootReducer = combineReducers({
    languageReducer
});


const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    // "languageReducer"
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


export const store = configureStore({
    reducer:persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    })
    // .concat(logger),

})

export const persistor = persistStore(store);